import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { AIAgentFormPage } from "~/pages/AIAgentFormPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/ai-agents_/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, id } = Route.useParams();
  useBreadCrumbs([
    { title: "Settings", link: `/${datasetSlug}/settings/api` },
    { title: "AI Agents", link: `/${datasetSlug}/settings/ai-agents` },
    { title: "Edit", link: `/${datasetSlug}/settings/ai-agents/${id}` },
  ]);
  return <AIAgentFormPage agentId={id} />;
}
